import { ScrollArea, Flex, Text, Skeleton, Box, Group } from '@mantine/core';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useCategoryContainerScrollAreaStyles, useCategoryContainerStyles } from './styles';

type Props = {
  data: any;
  isLoading: boolean;
  category: {
    name: string;
    id: number;
  };
  setCategory: Dispatch<
    SetStateAction<{
      name: string;
      id: number;
    }>
  >;
  foodItemRefs: any;
};

const CategoryContainer: FC<Props> = ({ data, isLoading, category, setCategory, foodItemRefs }) => {
  const { classes, cx } = useCategoryContainerStyles();
  const { classes: ScrollAreaClasses } = useCategoryContainerScrollAreaStyles();

  const scrollToCategory = (categoryId: number) => {
    const targetItem = foodItemRefs.current.find((ref: any) => {
      const refCategory = ref?.dataset?.categoryId;
      if (refCategory) {
        const parsed = JSON.parse(refCategory);
        return parsed.id === categoryId;
      }
      return false;
    });

    if (targetItem) {
      targetItem.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <>
      <ScrollArea type='never' classNames={ScrollAreaClasses}>
        <Group
          h={'100%'}
          px={12}
          // style={{
          //   display: 'flex',
          //   gap: 20,
          //   WebkitAlignItems: 'center',
          //   WebkitBoxAlign: 'center',
          // }}
          noWrap
          spacing={0}
          align='center'>
          {isLoading ? (
            <>
              {Array(3)
                .fill(0)
                .map((d, index) => (
                  <Skeleton key={index} h={24.8} width={84} mr={20} />
                ))}
            </>
          ) : (
            <>
              {/* <Text
                className={cx(classes.categoryText, { [classes.selectedCategory]: category.id === 0 })}
                onClick={() => setCategory((prev) => ({ ...prev, name: 'all', id: 0 }))}>
                All
              </Text> */}
              {data?.map((d: any, index: number) => (
                <Text
                  key={index}
                  className={cx(classes.categoryText, {
                    [classes.selectedCategory]: d?.category_id === category.id,
                    [classes.unSelectedCategory]: d?.category_id !== category.id,
                  })}
                  onClick={() => {
                    setCategory((prev) => ({ ...prev, name: d?.name?.trim().toLowerCase(), id: d?.category_id }));
                    scrollToCategory(d?.category_id);
                  }}>
                  {d?.name}
                </Text>
              ))}
            </>
          )}
        </Group>
      </ScrollArea>
    </>
  );
};

export default CategoryContainer;
